export enum AlertPageType {
  LOGIN = 'security'
}

export enum LoginAlert {
  INVALID_ACCOUNT = 'invalidAccount',
  INVALID_TOKEN_MESSAGE = 'InvalidTokenMessage',
  STRONG_PASSWORD_MESSAGE = 'StrongPasswordMessage',
  INVALID_USER = 'InvalidUser'
}
